import React from 'react';
import Time from 'react-time';
import ProjectIcon from '../icons/ProjectIcon.jsx';
import VerticalSeparator from '../VerticalSeparator.jsx';
import { BoardIcon } from '../icons/BoardIcon.jsx';
import { SurveyIcon } from '../icons/SurveyIcon.jsx';
import { ClockIcon } from '../icons/ClockIcon.jsx';
import { getOrgTermsContent } from '../../content/utils.js';
import { ProjectLink } from '../links/index.jsx';

const ChangeInsightsOverview = (props) => {
  const { initiative, survey } = props;

  return (
    <div className="component component-bg-white">
      <div className="flex flex-justify" style={{ alignItems: 'flex-end' }}>
        <div>
          <div className={`flex ${survey ? 'm-b-20' : ''}`}>
            <div className="flex header-item">
              <ProjectIcon />
              <strong className="text-muted m-r-12 m-l-8">
                {getOrgTermsContent('project')}:{' '}
              </strong>
              <ProjectLink projectId={initiative.project.id}>
                {initiative.project.name}
              </ProjectLink>
            </div>
            <VerticalSeparator />
            <div className="flex header-item">
              <BoardIcon />
              <strong className="text-muted m-r-12 m-l-8 text-capitalize">
                {initiative.type}:
              </strong>
              <strong>{initiative.title}</strong>
            </div>
          </div>

          {survey ? (
            <div className="flex">
              <div className="flex header-item">
                <SurveyIcon />
                <strong className="text-muted m-r-12 m-l-8 text-capitalize">
                  Feedback Form:
                </strong>
                <strong>{survey.title}</strong>
              </div>
              <VerticalSeparator />
              <div className="flex header-item">
                <ClockIcon />
                <strong className="text-muted m-r-12 m-l-8">
                  Feedback Dates:{' '}
                </strong>
                {survey.startDate && survey?.endDate ? (
                  <React.Fragment>
                    <strong>
                      <Time value={survey.startDate} format="M/D/YY" />
                    </strong>
                    <strong>
                      <span>&nbsp;- </span>
                      <Time value={survey.endDate} format="M/D/YY" />
                    </strong>
                  </React.Fragment>
                ) : null}
              </div>
              <VerticalSeparator />
              <div className="flex header-item">
                <strong className="text-muted m-r-12">Completion: </strong>
                <strong>
                  {initiative.participationSurveyCount
                    ? (
                        (initiative.participationCompletedSurveyCount * 100) /
                        initiative.participationSurveyCount
                      ).toFixed(2)
                    : 0}
                  % ({initiative.participationCompletedSurveyCount}/
                  {initiative.participationSurveyCount})
                </strong>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default ChangeInsightsOverview;
